import { ModelLayout } from '../components/model-size/ModelLayout';
import { useLegacyModelSizeService } from '../services/useLegacyModelSizeService';

export interface LegacyModelSizeContainerProps {}

export const LegacyModelSizeContainer: React.FC<React.PropsWithChildren<LegacyModelSizeContainerProps>> = () => {
  const { isHide, modelList, onClickMore, targetRef, displayButton, displayCount } = useLegacyModelSizeService();
  if (isHide) {
    return null;
  }

  return (
    <div ref={targetRef}>
      <ModelLayout
        modelList={modelList}
        onClickMore={onClickMore}
        displayCount={displayCount}
        displayButton={displayButton}
      />
    </div>
  );
};
